<div class="jobDetailsMainDiv">
    <div *ngIf="tgSettings?.EnableJobtoJobNavigation?.toLowerCase() ==='yes'">
        <div role="region" [attr.aria-label]="'Label_PreviousJob' | translate" *ngIf="bJDScroll && prevJob!= null"
            [ngClass]="{hideNextPrevInMob:prevJob == ''}"
            class="prevJobDetailsCard jdCard lightAccentBkg nga-slow nga-fade">


            <div class="jobDetailsLiner" *ngIf="prevJob != '' && prevJob?.Questions">

                <div class="questionClass">
                    <div *ngFor="let oQ of prevJob?.Questions | showPartialJobDetailsFields: JobFieldsToDisplay">
                        <span *ngIf="oQ?.ClassName == 'jobtitle'">
                            <span class="featuredJobs fa fa-fire" *ngIf="jobNextPrevHot(this,'prev')"
                                title="{{'AriaLabel_FeaturedJob' | translate}}">
                                <span class="screenReaderText">{{'AriaLabel_FeaturedJob' | translate}}</span>
                            </span>
                            <span class="referralJobs linkColor"
                                *ngIf="enableSocialReferral && !prevJob?.isSocialReferralJobRestricted"
                                title="{{'AriaLabel_AllowsReferral' | translate}}">
                                <i aria-hidden="true" class="fa fa-user"> <i aria-hidden="true"
                                        class="fa fa-user-o"></i></i>
                                <span class="screenReaderText">{{'AriaLabel_AllowsReferral' | translate}}</span>
                            </span>
                            <!-- [ng-space]="" [ng-enter]="" -->
                            <a (click)="jobDetailsSlide(prevJob,'prev')">
                                <h1 [ngClass]="oQ?.ClassName" [innerHTML]="oQ?.Value | translate"
                                    class="answer Nextjobs UnderLineLink" tabindex="0"></h1>
                            </a>
                        </span>
                        <p *ngIf="oQ?.ClassName == 'position3'|| oQ?.ClassName =='position1'" [ngClass]="oQ?.ClassName"
                            [innerHTML]="oQ?.Value | translate" class="answer"></p>

                    </div>
                </div>
                <div class="prev">
                    <a (click)="jobDetailsSlide(prevJob,'prev')"><i class="fa fa-chevron-circle-left"></i><span
                            class=" Nextjobs UnderLineLink">{{'Lbl_PreviousJob' | translate}}</span></a>
                </div>
            </div>
            <label [ngClass]="{hideNextPrevInMob:prevJob == ''}" *ngIf="prevJob == ''">{{'Lbl_NoPrevJob' |
                translate}}</label>
        </div>


    </div>
    <!-- [ngClass]="{hideNextPrevInMob:nextJob == ''}" -->
    <div *ngIf="tgSettings?.EnableJobtoJobNavigation?.toLowerCase()==='yes'">
        <div role="region" [attr.aria-label]="'Lbl_NextJob' | translate" *ngIf="bJDScroll && nextJob!= null"
            class="nextJobDetailsCard jdCard lightAccentBkg nga-slow nga-fade">
            <div class="jobDetailsLiner" *ngIf="nextJob != '' && nextJob?.Questions">

                <div class="questionClass">
                    <div *ngFor="let oQ of nextJob?.Questions | showPartialJobDetailsFields:JobFieldsToDisplay">

                        <span *ngIf="oQ?.ClassName == 'jobtitle'">
                            <span class="featuredJobs fa fa-fire" *ngIf="jobNextPrevHot(this, 'next')"
                                title="{{'AriaLabel_FeaturedJob' | translate}}">
                                <span class="screenReaderText">{{'AriaLabel_FeaturedJob' | translate}}</span>
                            </span>
                            <span class="referralJobs linkColor"
                                *ngIf="enableSocialReferral && !nextJob?.isSocialReferralJobRestricted"
                                title="{{'AriaLabel_AllowsReferral' | translate}}">
                                <i aria-hidden="true" class="fa fa-user"> <i aria-hidden="true"
                                        class="fa fa-user-o"></i></i>
                                <span class="screenReaderText">{{'AriaLabel_AllowsReferral' | translate}}</span>
                            </span>
                            <!-- [ng-space]="" [ng-enter]="" -->
                            <a (click)="jobDetailsSlide(nextJob,'next')">
                                <h1 [ngClass]="oQ?.ClassName" [innerHTML]="oQ?.Value | translate"
                                    class="answer Nextjobs UnderLineLink" tabindex="0"></h1>
                            </a>
                        </span>
                        <p *ngIf="oQ?.ClassName == 'position3'|| oQ?.ClassName =='position1'" [ngClass]="oQ?.ClassName"
                            [innerHTML]="oQ?.Value | translate" class="answer"></p>

                    </div>
                </div>
                <div class="next">
                    <!-- [disabled]="nextJob == ''" -->
                    <a (click)="jobDetailsSlide(nextJob,'next')" class=""><span
                            class="Nextjobs UnderLineLink">{{'Lbl_NextJob' | translate}}</span><i
                            class="fa fa-chevron-circle-right"></i></a>
                </div>
            </div>
            <label [ngClass]="{hideNextPrevInMob:nextJob == ''}" *ngIf="nextJob == ''">{{'Lbl_NoNextJob' |
                translate}}</label>
        </div>
    </div>
</div>